// BackendAPI error messages
export const AUTH_API_ERROR_MESSAGES = {
  INVALID_TOKEN: 'Invalid authentication token',
  TOKEN_EXPIRED: 'Authentication token has expired',
  TOKEN_NOT_FOUND: 'Authentication token not found in response',
  AUTH_USER_NOT_FOUND: 'User not found',
  AUTH_INVALID_PASSWORD: 'Invalid password',
  SERVER_ERROR: 'An unexpected server error occurred',
} as const;

// OIDC error messages
export const AUTH_OIDC_ERROR_MESSAGES = {
  TOKEN_EXCHANGE_FAILED: 'Failed to exchange authentication token',
  OIDC_INVALID_PASSWORD: 'Invalid email or password',
  OIDC_USER_NOT_FOUND: 'No user found with this email',
  SERVER_ERROR: 'Authentication service error occurred',
} as const;
